@if (showBackButton) {
<prism-ui-button-group
  key-id="continue-cancel-button-group"
  buttons-count="2"
  spacing="default"
  class="ccFlexbox"
>
  <!-- Show Back button for steps 2-6, Cancel button for step 1 -->
  <prism-ui-button
    slot="1"
    button-width="full"
    key-id="back-button"
    size="md"
    variant="secondary"
    type="button"
    is-icon-right-aligned="false"
    [isWaiting]="spinner"
    (click)="onBack()"
    >Back</prism-ui-button
  >
  <prism-ui-button
    slot="2"
    button-width="full"
    key-id="continue-button"
    size="md"
    variant="primary"
    type="submit"
    is-icon-right-aligned="false"
    [isWaiting]="spinner"
    >{{ primaryButtonName }}</prism-ui-button
  >
</prism-ui-button-group>
}
@if (!showBackButton) {
<prism-ui-button-group
  key-id="continue-cancel-button-group"
  buttons-count="2"
  spacing="default"
  class="ccFlexbox"
>
  <prism-ui-button
    slot="1"
    button-width="full"
    key-id="cancel-button"
    size="md"
    variant="secondary"
    type="button"
    is-icon-right-aligned="false"
    [isWaiting]="spinner"
    (click)="onCancel()"
    >Cancel</prism-ui-button
  >
  <prism-ui-button
    slot="2"
    button-width="full"
    key-id="continue-button"
    size="md"
    variant="primary"
    type="submit"
    is-icon-right-aligned="false"
    [isWaiting]="spinner"
    >{{ primaryButtonName }}</prism-ui-button
  >
</prism-ui-button-group>
}